import { Component, OnInit, OnDestroy } from '@angular/core';
import { PHBHPFeaturePackageConsumptionService } from '../ph-bhp-feature-package-consumption.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { ActivatedRoute } from '@angular/router';
import { ConsumptionConfig } from '../Models/ConsumptionConfig';
import { ConsumptionPeriod } from '../Models/Consumption';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-ph-bhp-parent-view-consumption',
  templateUrl: './ph-bhp-parent-view-consumption.component.html'
})
export class PhBhpParentViewConsumptionComponent implements OnInit, OnDestroy {
  
  subscription: Subscription;
  consumptionConfigDetail: ConsumptionConfig;
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  navTo: string;
  pastNavTo: string;
  periodName: string;
  consumptionID: number
  constructor(
    public appConfig: AppConfig,
    private service: PHBHPFeaturePackageConsumptionService, 
    private activeRouter: ActivatedRoute, 
    private layoutService: PHBHPLayoutPackageService
    ) { }

  ngOnInit() {
    this.appConfig.viewconsumption = false;
    this.consumptionID =  parseInt(this.activeRouter.snapshot.paramMap.get('Id'));
    this.periodName = this.activeRouter.snapshot.paramMap.get('period');
    if(this.layoutService.institutionID)
    {
        this.getConsumptionPeriodByConsumptionIdList();
      
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
        this.getConsumptionPeriodByConsumptionIdList();
     
    });   
    }
    ngOnDestroy(){
      if(this.subscription)
        this.subscription.unsubscribe();
    }
    getConsumptionPeriodByConsumptionIdList() {
          if(this.periodName === "m") {
            this.navTo = "m";
          }else if(this.periodName === "y") {
            this.navTo = "y";
          }else if(this.periodName === "q") {
            this.navTo = "q";
          }
    }

    onChildData(event){
      this.appConfig.editconsumption = event.key;
      if(event.val == "save"){
      this.appConfig.viewconsumption = true;
      }
      else if(event.val == "cancel"){
        this.appConfig.viewconsumption = false;
      }
    }
}
